var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"730px","height":"100px"}},[_c('div',{attrs:{"id":"particles-js"}})])
}]

export { render, staticRenderFns }